import {
  GETBLOCKCUSTOMEROPERATIONSLIST_SUCCESS,
  GETBLOCKCUSTOMEROPERATIONSLIST_FAILED,
  RESET_GETBLOCKCUSTOMEROPERATIONSLIST,
  LOADING_GETBLOCKCUSTOMEROPERATIONSLIST,
  NETWORK_ERROR_GETBLOCKCUSTOMEROPERATIONSLIST,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetGetBlockCustomerOperationsList = () => {
  return { type: RESET_GETBLOCKCUSTOMEROPERATIONSLIST };
};

const getBlockCustomerOperationsList =
  (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_GETBLOCKCUSTOMEROPERATIONSLIST });
    await partnerServices
      .post("getBlockCustomerOperationsList", userData, { headers: { AuthToken: authTokenIs } })
      .then((res) => {
        switch (res.status) {
          case 200:
            dispatch(getBlockCustomerOperationsListsuccess(res.data));
            break;
          default:
            dispatch(getBlockCustomerOperationsListFailed(res.data));
            break;
        }
      })
      .catch((err) => {
        dispatch({
          type: NETWORK_ERROR_GETBLOCKCUSTOMEROPERATIONSLIST,
          payload: err,
        });
      });
  };
function getBlockCustomerOperationsListsuccess(data) {
  return {
    type: GETBLOCKCUSTOMEROPERATIONSLIST_SUCCESS,
    payload: data,
  };
}
function getBlockCustomerOperationsListFailed(data) {
  return {
    type: GETBLOCKCUSTOMEROPERATIONSLIST_FAILED,
    payload: data,
  };
}

export { resetGetBlockCustomerOperationsList, getBlockCustomerOperationsList };
